module.exports = __webpack_public_path__ + "static/media/it.8c03ef5b.jpg";